import { Environment } from './environment.type';

export const environment: Environment = {
  production: false,
  stage: 'development',
  oidc: {
    authority: 'https://dev-cardinal.eshava.de',
    audience: 'https://dev-api.eshava.de',
    clientId: 'Eshava.UI.Angular.Portal-Dev',
    requireHttps: true,
    scope: 'openid profile email offline_access services.api.read'
  },
  baseUrls: {
    cardinalUrl: 'https://dev-cardinal.eshava.de',
    accountsUrl: 'https://dev-api.eshava.de/accounts',
    uiUrl: 'https://dev-portal.eshava.de'
  }
};